import { toast } from "sonner";
import api from "@/lib/api";

function triggerSave(objUrl, filename) {
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 1000);
}

// Save a Blob via an in-frame <a download> click on an object URL.
// No new tab and no network request — popup/ad blockers can't interfere.
export function downloadBlob(blob, filename) {
  const objUrl = URL.createObjectURL(blob);
  triggerSave(objUrl, filename);
  // Some browsers/extensions silently drop automatic downloads — offer a
  // real-click retry (a genuine user gesture is always honoured).
  toast(`Saving "${filename}"…`, {
    description: "Didn't get the file? Save it again:",
    duration: 10000,
    action: { label: "Save again", onClick: () => triggerSave(objUrl, filename) },
  });
  setTimeout(() => URL.revokeObjectURL(objUrl), 120000);
}

// Download a backend file: fetch the bytes over XHR first (works in every
// context), then save via in-frame blob click. Throws on HTTP errors so
// callers only report success once the bytes actually arrived.
export async function downloadFromUrl(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  let name = filename;
  if (!name) {
    const cd = res.headers["content-disposition"] || "";
    name = (cd.match(/filename="?([^";]+)/) || [])[1] || "download";
  }
  downloadBlob(res.data, name);
}

export function downloadText(text, filename, mime = "text/csv;charset=utf-8") {
  downloadBlob(new Blob([text], { type: mime }), filename);
}
